import { nextTick } from "vue";

export default {
  async beforeMount(el: HTMLElement, binding: { value: string }) {
    await nextTick();
    const observer = new IntersectionObserver(
      ([entry]) => {
        el.dataset.isWithinViewport = String(entry.isIntersecting);

        if (binding.value && typeof binding.value === "function") {
          binding.value(entry.isIntersecting, entry);
        }
      },
      {
        root: el.closest(el.dataset.rootContainerQueryForCulling),
        rootMargin: el.dataset.viewportCullingRootMargin || "100px",
        threshold: 0,
      }
    );
    // observer.observe(el);
    // observer.disconnect();

    observer.observe(el);

    el.__intersectionObserver__ = observer;
  },

  beforeUnmount(el: HTMLElement) {
    el.__intersectionObserver__.disconnect();
    delete el.__intersectionObserver__;
  },
};
